




























































































































import {Component, Prop, Vue} from 'vue-property-decorator';

import {getFileLink} from '@/api/filestorage';
import {converterFromPennyToRub} from '@/utils/common';
// eslint-disable-next-line no-unused-vars
import {IStatementStatusInfo, IStatusHistoryItem} from '@/utils/types';
import StatusFieldRaw from '@/components/elements/statement/Status/StatusFieldRaw.vue';
import {StatementStatus} from '@/utils/statementStatus';

@Component({
  components: {StatusFieldRaw},
  data: () => ({
    getFileLink,
    converterFromPennyToRub,
  }),
})
export default class StatusInfo extends Vue {
  loading = false;
  @Prop() data!: IStatusHistoryItem | any;
  @Prop() statementStatusInfo!: IStatementStatusInfo;
  @Prop({default: false}) once!: boolean;

  get paymentInfoLabels() {
    return [
      'checkingAccount',
      'bik',
      'correspondentAccount',
      'bankName',
      'SBPBankName',
      'SBPBankId',
      'SBPPhone'
    ]
  }

  get getStatusObject() {
    return this.data;
  }

  get processedFromFSSPTitleVisible() {
    return this.data.statusCode === StatementStatus.PROCESSED_FROM_FSSP;
  }

  get getDateSurcharge() {
    return new Date(this.statementStatusInfo.surchargeDate).toLocaleDateString()
  }

  get getDateParentSurcharge() {
    return new Date(this.statementStatusInfo.parentSurchargeDate).toLocaleDateString()
  }
}
